import * as React from "react"
import { ThemeCss, CheckIcon } from "gatsby-interface"
import { gatsbyCloudCdnIntegrationConfig as text } from "@modules/locales/default.json"

const featuresCss: ThemeCss = theme => ({
  fontSize: theme.fontSizes[1],
  margin: 0,
  listStyle: `none`,
  color: theme.colors.grey[50],

  li: {
    marginBottom: theme.space[2],
  },

  svg: {
    width: theme.fontSizes[2],
    height: `auto`,
    marginRight: theme.space[3],
    fill: theme.colors.purple[60],
    background: theme.colors.purple[20],
    borderRadius: theme.radii[6],
    padding: theme.space[0],
  },
})

export function GatsbyCloudCdnFeatures({ className }: { className?: string }) {
  return (
    <ul css={featuresCss} className={className}>
      {text.messages.features.map(feature => (
        <li key={feature}>
          <CheckIcon /> {feature}
        </li>
      ))}
    </ul>
  )
}
